// ChatWebUI.styles.ts
import styled from 'styled-components'

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 50;
  pointer-events: none;
`

export const ChatButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  border-radius: 9999px;
  background: linear-gradient(to right, #cc0000, #e60023);
  color: white;
  gap: 12px;
  margin-bottom: 45px;
  margin-right: -24px;
  pointer-events: auto;
  cursor: pointer;
`

export const ChatLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const ChatLabel = styled.span`
  font-size: 14px;
`
